import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-left\">\n<path d=\"M385.01 475L115 250L385.01 25\" stroke=\"currentColor\" stroke-width=\"35.5916\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol